import { P0, S, abs, core, max, moodK, scaleAt, sq } from '../../geometry';

export const zigzag = {
  name: 'Zigzag',
  colors: ['#E3A008', '#E5484D'],
  draw(m, t) {
    let A = 8,
      ph = 1.57 + 0.3 * S(t * 1.5),
      B = 3,
      pose = P0();
    if (m === 'happy') {
      A = 12 + 3 * abs(S(t * 7));
      ph = t * 6;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the peaks keep travelling along the crown.
    if (m === 'thinking') {
      A = 9;
      ph = t * 4;
      B = 3 + S(t * 4);
    }
    if (m === 'talking') {
      A = 6 + 6 * max(0, S(t * 10));
      B = 2 + 3 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      A = 16;
      B = 5;
      ph = 1.57;
    }
    if (m === 'paused') {
      A = 2;
      ph = t * 0.5;
      B = 0.5;
    }
    const wl = m === 'thinking' || m === 'happy' ? 1.9 : Math.PI;
    const crown = [...Array(7)].map((_, k) => [
      24 + (k * 52) / 6,
      30 - A * (0.5 + 0.5 * S(k * wl + ph)),
    ]);
    const low = [...Array(5)].map((_, k) => [
      38 + k * 6,
      74 + (k % 2 ? -B : B),
    ]);
    return {
      strokes: [
        { c: 'a', pts: crown, sharp: true, n: 42 },
        { c: 'b', pts: low, sharp: true, n: 30 },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes[1] = { ...f.strokes[1], o: 0 };
    f.strokes.unshift(
      core(scaleAt(sq(50, 54, 23, 13, 3.6), 50, 54, moodK(m, t)))
    );
    f.eyes = { x: 50, y: 54 };
    return f;
  },
};
